import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import { CommentConfirmDialog } from 'scenes/FinancialResults/components/CommentFormDialog/CommentConfirmDialog';
import { commentFinancialResult } from 'scenes/FinancialResults/sources/financialResults';

import { addComment } from '../queryKeyFactory';
import { useSendForApproval } from './useSendForApproval';

const sendForApprovalStatus = 9;

export const useCommentFinancialResult = () => {
  const [sendForApprovalMutation] = useSendForApproval();

  const showModal = useScreenModalV2(CommentConfirmDialog);

  const addCommentMutation = useMutation(addComment(), commentFinancialResult);

  const handleAction = async (fr) => {
    const { comment } = await showModal({
      fr: fr,
      title: 'Add comment',
      confirmActionLabel: 'Save',
      commentRequired: true,
    });

    await addCommentMutation.mutateAsync({ id: fr.id, comment });
    if (fr.status.id === sendForApprovalStatus) {
      await sendForApprovalMutation({ id: fr.id, comment });
    }
  };

  return [handleAction, addCommentMutation];
};
